import { createAction, props } from '@ngrx/store';
import { AccountTeamUserApiError } from './account-team-user.errors';
import { UserInvite, OrganizationUser } from './account-team-user.model';

// Load Users
export const LoadAccountTeamUsers = createAction('[Account Team User] Load Account Team Users');

export const SetAccountTeamUsers = createAction(
  '[Account Team User] Set Account Team Users',
  props<{ users: OrganizationUser[] }>(),
);

export const SetAccountTeamApiError = createAction(
  '[Account Team User] Set Account Team ApiError',
  props<{ error: AccountTeamUserApiError }>(),
);

export const RemoveAccountTeamApiError = createAction(
  '[Account Team User] Remove Account Team ApiError',
);

// Invite Users
export const InviteUser = createAction(
  '[Account Team User] Invite User',
  props<{ user: UserInvite }>(),
);

export const InviteUserSuccess = createAction(
  '[Account Team User] Invite User Success',
  props<{ user: OrganizationUser }>(),
);

export const InviteUserError = createAction(
  '[Account Team User] Invite User Error',
  props<{ error: AccountTeamUserApiError }>(),
);

export const ResetCallStateInviteUser = createAction(
  '[Account Team User] Reset Call State Invite User',
);

export const ResendInvitation = createAction(
  '[Account Team User] Resend Invitation',
  props<{ user: OrganizationUser }>(),
);

export const ResendInvitationSucceeded = createAction(
  '[Account Team User] Resend Invitation Succeeded',
  props<{ user: OrganizationUser }>(),
);

export const ResendInvitationErrored = createAction(
  '[Account Team User] Resend Invitation Errored',
  props<{ user: OrganizationUser }>(),
);

// TODO - retire legacy code STUD-2700
export const RemovePendingUser = createAction(
  '[Account Team User] Remove Pending User',
  props<{ user: OrganizationUser }>(),
);

export const RemovePendingUserFromOrg = createAction(
  '[Account Team User] Remove Pending User from Org',
  props<{ user: OrganizationUser }>(),
);

export const RemovePendingUserSucceeded = createAction(
  '[Account Team User] Remove Pending User Succeeded',
  props<{ user: OrganizationUser }>(),
);

export const RemovePendingUserErrored = createAction(
  '[Account Team User] Remove Pending User Errored',
  props<{ user: OrganizationUser }>(),
);

// Update roles
export const UpdateOrganizationRoles = createAction(
  '[Account Team User] Update Organization Roles',
  props<{ userId: string; organizationRole: string[] }>(),
);

export const UpdateOrganizationRolesSuccess = createAction(
  '[Account Team User] Update Organization Roles Success',
  props<{ user: OrganizationUser }>(),
);

export const UpdateOrganizationRolesError = createAction(
  '[Account Team User] Update Organization Roles Error',
  props<{ error: AccountTeamUserApiError }>(),
);

export const ResetCallStateUpdateUserRole = createAction(
  '[Account Team User] Reset Call State Update Role',
);

// Remove user
export const RemoveUserConfirmation = createAction(
  '[Account Team User] Remove User Confirmation',
  props<{ user: OrganizationUser }>(),
);

// TODO - retire legacy code STUD-2700
export const RemoveUser = createAction('[Account Team User] Remove User');

export const RemoveUserFromOrg = createAction('[Account Team User] Remove User from Org');

export const RemoveUserSuccess = createAction(
  '[Account Team User] Remove User Successful',
  props<{ userId: string }>(),
);

export const RemoveUserError = createAction(
  '[Account Team User] Remove User Error',
  props<{ error: AccountTeamUserApiError }>(),
);

export const ResetCallStateRemoveUser = createAction(
  '[Account Team User] Reset Call State Remove User',
);
